<template>
  <div class="main-container-view-proposals ">

    <b-link @click="redirectLastRoute($router)" class="text-blue d-block mb-1">
      <span>
        {{ $t('tracking.goBack') }}
      </span>
    </b-link>
    <header-images-preview 
      class="mb-1"
      :data_header="details || {images: []}"
      :loading="!loaded"
      :is_avaible_to_editing="!vanity_name"
      @edit_proposal="editProposal"
      :key="update_header_images_preview"
      v-if="details && details.details_proposal_uuid"
    />
    <b-row class="m-0">
      <b-col :class="`${!vanity_name || is_in_sidebar ? 'col-12' : 'col-lg-8 col-12'} p-0 w-100`">
        <title-and-description-preview
          :data_header="details ? details : {}"
          :is_avaible_to_editing="!vanity_name"
          :loading="!details"
          @edit_proposal="editProposal"
          class="mb-1"
        />
        <donut-metrics 
          v-if="!is_in_sidebar && total_followers > 0"
          :class="`${!vanity_name ? 'col-8' : 'col-12'} p-0`" 
          :networks="details ? details.followers_count : {}" 
          :followers_by_username="details ? details.followers_by_username : []"
          :loading="!loaded"
        ></donut-metrics>

        <b-button v-if="!is_brand && !vanity_name" class="add-deal-action my-2" variant="add-deal-action" @click="modal_edit_vanity = true"> {{ $t('creator.EditVanity') }} </b-button>

        <!-- Public deals -->
        <deals-section-with-filters
          :show_filters="true"
          :filters_open="show_filter"
          :has_active_filters="has_active_deal_filters"
          :active_filter_count="active_filter_count"
          :loading="!loaded"
          :proposals="proposals"
          :selected_deal_radio.sync="selected_deal_radio"
          :is_in_sidebar="is_in_sidebar"
          :is_avaible_to_editing="!vanity_name"
          :current_page="current_page"
          :total_rows="total_rows"
          :per_page="per_page"
          :is_brandme_talent="details ? details.is_brandme_talent : false"
          @toggle_filters="show_filter = !show_filter"
          @filter_change="onFilterChange"
          @deal_selected="dealSelected"
          @edit_deal="editProposal"
          @update_current_page="handlePageChange"
        />

      <similar-proposals v-if="details && vanity_name && !chat_uuid" :networks="getNetworksUsedInProposals(details ? details.deals : ['instagram'])"></similar-proposals>
        
      </b-col>
      <b-col class="col-4 p-0 w-100 mt-2 pl-1 d-none d-lg-block" v-if="vanity_name && !is_in_sidebar">
        <resume-proposal-checkout
          :loading="!loaded"
          :is_in_sidebar="is_in_sidebar"
          :details="details"
          :proposal="proposal_for_checkout ? proposal_for_checkout : {}"
          :is_brandme_talent="selected_deal_radio ? selected_deal_radio.is_brandme_talent : false"
          :string_key="string_key"
          :deal_selected="selected_deal_radio"
          :buy_loader="buy_loader"
          :is_authenticated="is_authenticated"
          :get_balance="get_balance"
          :apply_balance="apply_balance"
          :vanity_name="vanity_name"
          :view_change_balance.sync="view_change_balance"
          :is_brand="is_brand"
          :balance_discount.sync="balance_discount"
          :total_discounted="total_discounted"
          @redirect-vanity="redirectVanity"
          @message-action="messageAction"
          @delete-discount="deleteDiscount"
          @apply-discount="applyDiscount"
          @buy-action="buyAction"
        />
      </b-col>
    </b-row>
    <!-- Container fixed responsive actions buy/login to buy -->
    <div class="mt-2 container-nav-fixed" :class="{'d-lg-none': !is_in_sidebar}" v-if="(!is_in_sidebar || force_show_buy_button) && is_brand">
      <b-button class="btn-bag-shopping" variant="btn-bag-shopping" @click="modalBuy()">
        <div class="d-flex d-flex align-items-center">
          <feather-icon icon="ShoppingBagIcon" size="24" />
          <div class="ml-1">
            <span class="d-flex text-order">{{ $t('creator.orderSummary') }}</span>
            <span v-if="!selected_deal_radio.is_brandme_talent">$ {{ separatebycomma(selected_deal_radio.price) }}</span>
            <span v-else>
              <span v-for="index in selected_deal_radio.range_price" :key="index">$</span>
            </span>
          </div>
        </div>
      </b-button>
      <b-button 
        class="blue-button btn-buy col-4"
        variant="blue-button"
        @click="buyAction" 
        :disabled="!!$route.query.uuid" 
        v-if="!is_your_proposal"
      >
        <span v-if="!buy_loader">{{ (!is_authenticated) ? $t('creator.LoginToBuy') : (selected_deal_radio.is_brandme_talent ? $t('creator.requestPrice') : $t('creator.buyNow')) }}</span><b-spinner small class="mt-0" v-if="buy_loader"></b-spinner> </b-button>
    </div>
    <!-- ------------------------------- -->
    
    <modal-login :open_modal="open_modal_login" :key="update_modal_login"></modal-login>

    <modal-brandme
        :key="change_modal_deleted"
        :show_modal="show_modal_delete"
        @hidden="show_modal_delete = false"
        v-if="show_modal_delete"
      >
        <!-- TITLE -->
        <template #title>
          <div class="w-100 text-center">
            <h4 class="mb-0 font-weight-bold">
              {{ $t('creator.deleteDeal') }}
            </h4>
          </div>
        </template>

        <!-- BODY -->
        <template #body>
          <div class="px-1">

            <p class="text-center mb-2 font-weight-medium">
              {{ $t('creator.sureDeletedDeal') }}
            </p>

            <div class="deal-delete-card">

              <h6 class="mb-1 font-weight-bold text-overflow">
                {{ deal_to_delete.title }}
              </h6>

              <p class="text-muted small mb-1 text-overflow ">
                {{ deal_to_delete.description }}
              </p>

              <div class="deal-price-confirm">
                $ {{separatebycomma(deal_to_delete.price)}} USD
              </div>

            </div>

            <p class="text-danger small text-center mt-1 mb-0">
             {{ $t('creator.deleteDealConfirmation') }}
            </p>

          </div>
        </template>

        <!-- FOOTER -->
        <template #footer>
          <div class="d-flex justify-content-between w-100">
            
            <b-button 
              variant="outline-secondary" 
              class="w-50 mr-1"
              @click="closeModalConfirmationDelete"
            >
              {{ $t('creator.cancel') }}
            </b-button>

            <b-button 
              variant="danger" 
              class="w-50 ml-1"
              @click="confirmDelete"
            >
              {{ $t('creator.delete') }}
            </b-button>

          </div>
        </template>
    </modal-brandme>
        

    <sidebar-edit-proposal
      v-if="open_sidebar_edit"
      class="open-sidebar-edit-proposal" 
      :open_sidebar_edit="open_sidebar_edit"
      :details="details"
      :key="update_sidebar_edit"
      :section_dad="section_to_edit"
      :data_for_sidebar="data_for_sidebar"
      :chat_uuid="chat_uuid"
      @update_proposal="updateProposal"
      @update_deals="updateDeals"
      @update_private_deal="updatePrivateDeals"
      @close_siderbar="closeSidebarEdit"
      :hide_sidebar="false"
    ></sidebar-edit-proposal>
    <modal-brandme
      size="md"
      v-if="modal_edit_vanity"
      :show_modal="modal_edit_vanity"
      @hidden="modal_edit_vanity = false"
    >
    <template #title>{{ $t('creator.EditVanity') }}</template>
  
      <template #body>
        <edit-vanity-name @close_modal="modal_edit_vanity = false"/>
      </template>
    </modal-brandme>
  </div>
</template>
      
<script>
import { BCol, BLink, BRow, BButton, BSpinner } from "bootstrap-vue";
import { proposalsDealsRepository, crudDealsRepository } from "@/infrastructure/proposals/proposals.repository";
import { isDiscountValid, applyBalanceDiscount, validateOnlyNumbers, getNetworksUsedInProposals } from '@/domain/proposal/proposal.domain';
import { isBrand } from '@/domain/user/access.domain';
import { makeLoadProposalsDealsUseCase, makeLoadProposalsPageUseCase, makeCreateChatBrandmeTalentUseCase, makeExecuteProposalBuyFlowUseCase, makeLoadPrivateDeals, makeDeleteDealUseCase } from "@/application/proposals/loadProposalsDeals.usecase";
import { redirectLastRoute, showToast } from '@/libs/utils/others';
import { getUserData } from '@/libs/utils/user';
import { separatebycomma } from '@/libs/utils/formats';
import TitleAndDescriptionPreview from "@/views/components/proposals/components/TitleAndDescriptionPreview.vue";
import HeaderImagesPreview from "@/views/components/proposals/components/HeaderImagesPreview.vue";
import DonutMetrics from "./components/DonutMetrics.vue";
import ResumeProposalCheckout from "@/views/pages/proposals/stepper/viewProposals/components/resumeProposalCheckout.vue";
import DealsSectionWithFilters from "@/views/pages/proposals/stepper/viewProposals/components/DealsSectionWithFilters.vue";

export default {
  name: "viewProposals",
  components: {
    BCol,
    BLink,
    BRow,
    BButton,
    BSpinner,
    HeaderImagesPreview,
    DonutMetrics,
    TitleAndDescriptionPreview,
    ResumeProposalCheckout,
    DealsSectionWithFilters,
    SimilarProposals: () => import('@/views/pages/proposals/stepper/viewProposals/components/SimilarProposals.vue'),
    ModalLogin: () => import('@/views/components/modal/ModalLogin.vue'),
    SidebarEditProposal: () => import('@/views/pages/proposals/stepper/sidebarEditProposal.vue'),
    modalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
    editVanityName: () => import('@/views/components/proposals/components/editVanityName.vue')
  },
  data() {
    return {
      proposals: [],
      details: null,
      current_page: 1,
      per_page: 5,
      current_page_private_deals: 1,
      per_page_private_deals: 5,
      selected_deal_radio: { price : 0, licensing: null },
      string_key: null,
      buy_loader: false,
      loaded: false,
      proposal_for_checkout: null,
      apply_balance: false,
      balance_discount: 0,
      total_discounted: 0,
      view_change_balance: false,
      checked_options: [], // ? 
      modal_buy: false,
      change_modal: 0,
      is_your_proposal: false,
      update_modal_login: false,
      open_modal_login: false,  
      total_rows: 0,
      total_rows_private_deals: 0,
      private_deals: [],
      data_for_sidebar: null,
      section_to_edit: null,
      open_sidebar_edit: false,
      update_sidebar_edit: 0,
      update_header_images_preview: 0.1,
      total_followers: 0,
      show_modal_delete: false,
      deal_to_delete: null,
      change_modal_deleted: 0,
      active_filters: { query: '', networks: [], price_min: null, price_max: null },
      active_private_filters: { query: '', networks: [], price_min: null, price_max: null },
      show_filter: false,
      show_private_filter: false,
      deals_filters: null,
      private_deals_filters: null,
      modal_edit_vanity: false,
    };
  },  
  computed: {
    user_data() {
      return getUserData();
    },
    vanity_name() {
      return this.$route.params.vanity_name || this.vanity_name_dad;
    },
    is_brand() {
      return isBrand(this.user_data);
    },
    is_authenticated() {
      return this.user_data !== null;
    },
    has_active_deal_filters() {
      return this.hasActiveFilters(this.active_filters);
    },
    active_filter_count() {
      return this.getActiveFilterCount(this.active_filters);
    },
    has_active_private_deal_filters() {
      return this.hasActiveFilters(this.active_private_filters);
    },
    active_private_filter_count() {
      return this.getActiveFilterCount(this.active_private_filters);
    },
    get_balance() {
      if (this.is_authenticated) return this.user_data.balance;
      return 0
    },
  },
  props: {
    force_show_buy_button: {
      type: Boolean,
      default: false,
    },
    is_in_sidebar: {
      type: Boolean,
      default: false,
    },
    vanity_name_dad: {
      type: String,
      default: null,
    },
    is_adding_deal: {
      type: Boolean,
      default: false,
    },
    chat_uuid: {
      type: String,
      default: null,
    }
  },
  async created() {
    await this.loadInitialData(this.current_page);
  },
  methods: {
    closeSidebarEdit() {
      this.open_sidebar_edit = false;
      this.$emit("close_siderbar");
    },
    redirectLastRoute,
    separatebycomma,
    updatePrivateDeals(response, action) {
      if (action === 'delete') {
        this.private_deals = this.private_deals.filter(d => d.uuid !== response);
      } else if (action === 'create') {
        this.private_deals.push(response);
        this.closeSidebarEdit();
      } else if (action === 'update') {
        const index = this.private_deals.findIndex(d => d.uuid === response.uuid);
        if (index !== -1) {
          this.$set(this.private_deals, index, response);
        }
      }
      this.$emit('update_deals', response);
      this.$emit('close_siderbar', response,);  
    },
    getNetworksUsedInProposals,
    deleteDiscount() {
      this.apply_balance = false;
      this.balance_discount = 0;
    },
    updateProposal(response, key) {
      if (key) {
        this.details = { ...this.details, [key]: response };
      }

      if (key === 'images') this.update_header_images_preview += 0.1;
    
      if (!key) {
        this.details = response;
      }
    },
    updateDeals(response, action) {
      if (action === 'delete') {
        this.proposals = this.proposals.filter(deal => deal.uuid !== response);
      } else if (action === 'update') {
        const index = this.proposals.findIndex(deal => deal.uuid === response.uuid);
        if (index !== -1) {
          this.$set(this.proposals, index, response);
        }
      } else if (action === 'create') {
        this.proposals.push(response);
      }
      this.$emit('update_deals');
    },
    modalBuy() {
      this.modal_buy = true,
      this.change_modal += 1
    },
    applyDiscount() {
      if (isDiscountValid(this.balance_discount, this.get_balance, this.checked_options, this.selected_deal_radio)) {
        this.apply_balance = true;
        this.total_discounted = applyBalanceDiscount(this.balance_discount, this.checked_options, this.selected_deal_radio);
        this.view_change_balance = false
      }
    },
    editProposal(section, data) {
      this.section_to_edit = section;
      this.data_for_sidebar = data;
      this.open_sidebar_edit = true; this.update_sidebar_edit += 1;
    },
    closeModalConfirmationDelete() {
      this.show_modal_delete = false;
      this.change_modal_deleted += 1;
      this.deal_to_delete = null;
    },
    openModalConfirmationDelete(deal) {
      this.deal_to_delete = deal
      this.show_modal_delete = true
      this.change_modal_deleted += 1

    },
    async confirmDelete() {
      if (!this.deal_to_delete) return;

      await this.deleteDeal(this.deal_to_delete);

      this.closeModalConfirmationDelete()
    },
    async deleteDeal(deal) {
      try {
        const execution = makeDeleteDealUseCase({ crudDealsRepository }, deal.uuid);
        await execution();
        this.updatePrivateDeals(deal.uuid, 'delete');
        showToast(this, 'success', 'BellIcon', 'creator.titleDeleteDeal', 'creator.textDeleteDeal');
      } catch (error) {
        showToast(this, 'danger', 'AlertCircleIcon', error.message, '', { translate_title: false, translate_text: false, position: 'top-right' });
      }
    },
    onlyNumbers(event) {
      validateOnlyNumbers(event);
    },
    hasActiveFilters(filters) {
      const { query, networks, price_min, price_max } = filters;
      return !!(query || networks.length || price_min !== null || price_max !== null);
    },
    getActiveFilterCount(filters) {
      const { query, networks, price_min, price_max } = filters;
      return (query ? 1 : 0) + networks.length + (price_min !== null || price_max !== null ? 1 : 0);
    },
    buildDealsFilters(filters) {
      const { query, networks, price_min, price_max } = filters;
      const body = {};

      if (query) body.query = query;
      if (networks.length) body.networks = networks;
      if (price_min !== null && price_min !== undefined && price_min !== '') body.price_min = price_min;
      if (price_max !== null && price_max !== undefined && price_max !== '') body.price_max = price_max;

      return body;
    },
    onFilterChange(filters, type = 'proposals') {
      if (type === 'private_deals') {
        this.active_private_filters = filters;
      } else {
        this.active_filters = filters;
      }

      this.filteredProposals(type);
    },
    async filteredProposals(type = 'proposals') {
      const filters = type === 'private_deals' ? this.active_private_filters : this.active_filters;
      const body = this.buildDealsFilters(filters);

      if (type === 'private_deals') {
        this.private_deals_filters = body;
      } else {
        this.deals_filters = body;
      }

      this.handlePageChange(1, type);
    },
    async handlePageChange(page, type = 'proposals') {
      const is_private = type === 'private_deals';
      const current = is_private ? 'current_page_private_deals' : 'current_page';
      this[current] = page;
      await this.loadPage(type, page);
    },
    async loadInitialData(page) {
      const load_data = makeLoadProposalsDealsUseCase({ proposalsDealsRepository }, this.vanity_name, page, this.per_page, this.chat_uuid, this.current_page_private_deals, this.per_page_private_deals);
      
      try {
        const { proposals, details, proposal_for_checkout, string_key, private_deals } = await load_data();
        this.details = { ...details, is_in_sidebar: false, uploaded_images: false, loaded_ia_title: false };
        this.total_followers = details.total_followers || 0;
        this.proposal_for_checkout = proposal_for_checkout;
        this.assignProposals(proposals, string_key);
        this.assignPrivateDeals(private_deals);
      } catch (error) {
        this.details = {};
        this.proposals = [];
        this.total_rows = this.total_rows_private_deals = 0;
        showToast(this, 'danger', 'AlertCircleIcon', error.message, '', { translate_title: false, translate_text: false, position: 'top-right' });
      }
    },
    async loadPage(type, page) {
      const is_private = type === 'private_deals';
      const load_data = is_private ? makeLoadPrivateDeals({ proposalsDealsRepository }, this.chat_uuid, page, this.per_page_private_deals, this.private_deals_filters) : makeLoadProposalsPageUseCase({ proposalsDealsRepository }, this.vanity_name, page, this.per_page, this.deals_filters);

      try {
        const result = await load_data();
        is_private ? this.assignPrivateDeals(result.proposals) : this.assignProposals(result.proposals, result.string_key);
      } catch (error) {
        if (is_private) { 
          this.private_deals = []; 
          this.total_rows_private_deals = 0; 
        } else { 
          this.proposals = []; 
          this.total_rows = 0; 
        }
        showToast(this, 'danger', 'AlertCircleIcon', error.message, '', { translate_title: false, translate_text: false, position: 'top-right' });
      }
    },
    assignProposals(proposals, string_key = null) {
      this.proposals = proposals?.results ?? [];
      this.total_rows = proposals?.count ?? 0;
      this.string_key = string_key;
      this.selected_deal_radio = this.proposals.length > 0 ? this.proposals[0] : { price: 0, licensing: null };
      this.loaded = true;
    },
    assignPrivateDeals(private_deals) {
      this.total_rows_private_deals = private_deals?.count ?? 0;
      this.private_deals = private_deals?.results ?? [];
    },
    dealSelected(deal) {
      this.selected_deal_radio = deal;

      // getTotal(this.checked_options, this.deal_selected);
      // this.applyDiscount();
    },
    redirectVanity() {
      if (this.vanity_name) {
        this.$router.push({ name: 'user_profile', params: { user: this.vanity_name } });
      }
    },
    async messageAction() {
      if (!this.is_authenticated) {
        this.openModalLogin();
        return;
      }
      try {
        const createChat = this.buildCreateChatUsecase();
        const response = await createChat();
        this.navigateToChat(response.uuid);
      } catch (error) {
        showToast(this, 'danger', 'AlertCircleIcon', error.message, '', { translate_title: false, translate_text: false, position: 'top-right' });
      }
    },
    openModalLogin() {
      this.open_modal_login = true;
      this.update_modal_login = !this.update_modal_login;
    },
    buildCreateChatUsecase() {
      return makeCreateChatBrandmeTalentUseCase({ proposalsDealsRepository }, this.details.id);
    },
    navigateToChat(chatUuid) {
      if (this.$route.name === 'chat-proposal' && this.$route.params.chat_uuid === chatUuid) {
        showToast(this, 'success', 'BellIcon', 'creator.YouFind', 'creator.chatActive');
        return;
      }
      this.$router.push({ name: 'chat-proposal', params: { chat_uuid: chatUuid } }).catch(() => {});
    },
    async buyAction() {
      if (!this.is_authenticated) {
        this.openModalLogin();
        return;
      }

      this.buy_loader = true;
      try {
        const executeBuyFlow = makeExecuteProposalBuyFlowUseCase(
          { proposalsDealsRepository },
          {
            deal_selected: this.selected_deal_radio,
            is_brandme_talent: this.selected_deal_radio.is_brandme_talent,
            apply_balance: this.apply_balance,
            balance_discount: this.balance_discount,
            user_id: this.details.id,
          },
        );

        const result = await executeBuyFlow();
        if (result.type === 'chat') {
          this.navigateToChat(result.chat_uuid);
        } else {
          window.location.href = result.url;
        }
      } catch (error) {
        showToast(this, 'danger', 'AlertCircleIcon', error.message, '', { translate_title: false, translate_text: false, position: 'top-right' });
      } finally {
        this.buy_loader = false;
      }
    },
  },
  watch: {
    is_adding_deal(newValue) {
      if (newValue) {
        this.open_sidebar_edit = true;
        this.section_to_edit = 'deals';
        this.data_for_sidebar = { };
        this.update_sidebar_edit += 1;
        this.$emit('is_adding_deal', false);
      }
    },
  }
};
</script>
<style>
.open-sidebar-edit-proposal > .b-sidebar-right {
    animation: sidebar-edit-proposal 500ms;
  }
  @keyframes sidebar-edit-proposal {
  0% {
    transform: translateX(500px)
  }
  100% {
    transform: translateX(0px)
  }
}
</style>
<style lang="scss" scoped>

.main-container-view-proposals {
  margin: 0 auto;
  max-width: 1430px;
}
.container-nav-fixed {
  width: 100%;
  height: 80px;
  position: sticky;
  background-color: white;
  left: 0;
  bottom: 0;
  display: flex;
  padding: 0 0.8em;
  justify-content: space-between;
  align-items: center;
  box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
  z-index: 10;

  .btn-bag-shopping {
    border-color: #ced4da;
    font-size: 0.875rem;
    margin: 12px 0px 12px 0px;
    height: auto;
    padding: 10px;
  }
  .btn-bag-shopping:hover {
    background-color: rgba(0, 0, 0, 0.025);
  }
  .text-order {
    color:#495057;
    font-size: .745rem !important;
    margin-block: 4px;
  }

  .btn-buy {
    height: 45px !important;
    padding: 4px 1em !important;

    @media(max-width: 700px) {
      width: auto !important;
      padding: 4px 1em !important;
    }
  }

  @media(max-width: 500px) {
    padding: 0 1em;
  }
}
.deal-delete-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  background: #f9fafb;
}

.deal-price-confirm {
  font-size: 16px;
  font-weight: bold;
  color: var(--primary, #7367f0);
}
.text-overflow {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.add-deal-action {
  width: 100%;
  color: #3b8DA8;
  background-color: #E6f2f6;
  border: 1px solid #3b8DA8;
  padding: 2em;
  border-radius: 1em;
}
.add-deal-action:hover {
  color: #ffff;
  transition: all 500ms;
  background-color: #3b8DA8;
}
</style>